import type { SpaceGqlModel } from '../gql/SpaceGqlModel'
import { Button, IconButton, Paper, TextField, Typography } from '@mui/material'
import '../../core/modal/modal.css'
import './CreateSpacePanel.css'
import { useState } from 'react'
import { useDiRef } from '@/common/react/di-hooks'
import type { ISpacesService } from '../services/SpacesService'
import CloseIcon from '@mui/icons-material/Close'
import type { ModalProps } from '../../core/modal/ModalContext.tsx'
import type { OperationResult } from '@/common/errors/OperationResult'

export type CreateSpacePanelProps = ModalProps<OperationResult<SpaceGqlModel | undefined>>

export function CreateSpacePanel({ setModalSuccess, cancelModal }: CreateSpacePanelProps) {
  const [spaceName, setSpaceName] = useState('')
  const [error, setError] = useState('')
  const spacesService = useDiRef<ISpacesService>('SpacesService')

  async function handleSubmit(e: React.FormEvent) {
    setError('')
    e.preventDefault()
    const op = await spacesService.createSpace(spaceName)
    if (op.isError()) {
      setError(op.error.message ?? '')
      return
    }

    setModalSuccess(op)
  }

  return (
    <>
      <Paper className="modalCard" elevation={3}>
        <IconButton
          onClick={cancelModal}
          size="small"
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
        <Typography variant="h5" align="center" className="modalTitle">
          Create a Space
        </Typography>

        <form onSubmit={handleSubmit} className="modalForm">
          <Typography variant="caption" align="left" className="modalCaption">
            Create a Space
          </Typography>
          <TextField
            label="e.g. MyProject, Study, Entertainment"
            variant="outlined"
            size="small"
            value={spaceName}
            onChange={(e) => setSpaceName(e.target.value)}
            className="modalInput createSpaceInput"
          />
          <Button type="submit" variant="contained" color="primary" className="modalBtn" fullWidth>
            Create
          </Button>
          {error && (
            <div>
              <Typography className="errorLabel">
                Error:
                {error}
              </Typography>
            </div>
          )}
        </form>
      </Paper>
    </>
  )
}
